module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-CigaretteBreakOnTheWater-Web-1280.55b47ae7.jpg";